import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { storeToken, storeUser } from "../../reducers/app.reducer";
import { forgotPasswordAPI, loginAPI } from "./login.component.service";
import { formValidate } from "../../utils/validation.utils";

const forgotPasswordValidation = [
  {
    name: "username",
    type: "REQUIRED",
    message: "Username is required !",
  },
];

const validations = [
  {
    name: "username",
    type: "REQUIRED",
    message: "Username is required !",
  },

  {
    name: "password",
    type: "REQUIRED",
    message: "Password is required !",
  },
];

const LoginComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [tab, setTab] = useState("login");
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState({});

  const handleChange = (name, value) => {
    setValues({ ...values, [name]: value });
  };

  const handleLogin = async (e = null) => {
    if (e) e.preventDefault();
    
    // Clear previous errors and set loading state
    setErrors({});
    setAlert({});
    setError("");
    setIsLoading(true);
    
    // Validate form fields
    const errorResp = formValidate({ validations, values });
    if (errorResp.status) {
      setErrors(errorResp.errors);
      setIsLoading(false);
      return;
    }

    try {
      const loginResp = await loginAPI(values);

      if (loginResp.status) {
        dispatch(storeUser(loginResp.data.user));
        dispatch(storeToken(loginResp.data.token));
        setValues({});
        setErrors({});
        navigate("/");
      } else {
        if (loginResp.message === "Please enter the verification code") {
          setTab("verification");
        } else {
          const errorMessage = loginResp.message || "Invalid username or password. Please try again.";
          setError(errorMessage);
          setAlert({ show: true, type: "danger", message: errorMessage });
        }
      }
    } catch (error) {
      console.error("Login error:", error);
      setError("An error occurred during login. Please try again later.");
      setAlert({ show: true, type: "danger", message: "An error occurred during login. Please try again later." });
    } finally {
      setIsLoading(false);
    }
  };
  console.log({values});

  const handleForgotPassword = async (e = null) => {
    setErrors({});
    setAlert({});
    if (e) e.preventDefault();
    const errorResp = formValidate({
      validations: forgotPasswordValidation,
      values,
    });
    console.log({ errorResp });
    if (errorResp.status) {
      setErrors(errorResp.errors);
      return;
    }

    const forgotResp = await forgotPasswordAPI(values.username);
    console.log({ forgotResp });
    if (forgotResp.status) {
      setAlert({ show: true, type: "success", message: forgotResp.message });
    } else
      setAlert({ show: true, type: "danger", message: forgotResp.message });
  };

  return (
    <div className="ds-auth">
      {/* Brand aside */}
      <aside className="ds-auth-aside">
        <div className="inner">
          <img
            src="/assets/img/semi360-logo.svg"
            alt="semi 360"
            style={{ height: 30, filter: "brightness(0) invert(1)", marginBottom: 40 }}
          />
          <h2>Source smarter.<br />Buy faster.</h2>
          <p>
            Sign in to search 500M+ components, match your BOM against live
            inventory, and manage your orders in one place.
          </p>
        </div>
        <img className="glyph" src="/assets/img/logo-360-mark.svg" alt="" />
      </aside>

      {/* Form */}
      <main className="ds-auth-main">
        <form onSubmit={handleLogin} className="ds-auth-card">
          <p className="ds-eyebrow" style={{ margin: 0 }}>Welcome back</p>
          <h1>Sign in to your account</h1>
          <p className="lede">We are happy to see you back.</p>

          <div className="ds-field">
            <label htmlFor="username">Username</label>
            <div className="ds-input">
              <input
                type="text"
                id="username"
                name="username"
                value={values.username || ""}
                onChange={(e) => handleChange("username", e.target.value)}
                placeholder="Enter your username"
                required
              />
            </div>
            {errors.username && (
              <span style={{ color: "var(--danger)", fontSize: 12 }}>{errors.username}</span>
            )}
          </div>

          <div className="ds-field">
            <div className="ds-row ds-between">
              <label htmlFor="password">Password</label>
              <a className="ds-link" style={{ cursor: "pointer" }} onClick={handleForgotPassword}>
                Forgot Password?
              </a>
            </div>
            <div className="ds-input">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={values.password || ""}
                onChange={(e) => handleChange("password", e.target.value)}
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                className="trail"
                onClick={() => setShowPassword(!showPassword)}
                aria-label="Toggle password"
              >
                <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
              </button>
            </div>
            {errors.password && (
              <span style={{ color: "var(--danger)", fontSize: 12 }}>{errors.password}</span>
            )}
          </div>

          {error && <div className="alert alert-danger" style={{ margin: 0 }}>{error}</div>}

          <button
            type="submit"
            className="ds-btn ds-btn-primary ds-btn-block ds-btn-lg"
            disabled={isLoading}
          >
            {isLoading ? "Signing in…" : "Sign in"}
          </button>

          <p style={{ textAlign: "center", color: "var(--fg-3)", margin: 0 }}>
            Don't have an account? <Link className="ds-link" to="/register">Sign up</Link>
          </p>
        </form>
      </main>
    </div>
  );
};

export default LoginComponent;
